module.exports = __webpack_public_path__ + "img/arnica.5da6e2a9.png";